<template>
  <div class="ebc-root">
    <div class="ebc-header">
      <span class="ebc-header__title">
        <i class="el-icon-box" />
        {{ $l('section_booking_container_detail') || '订舱货柜明细' }}
      </span>
      <el-button type="primary" plain size="mini" @click="selectorVisible = true">
        {{ $l('btn_select_container') || '选择' }}
      </el-button>
    </div>

    <PageMain :data="selectedList" @remove="removeItem" @update-row="updateRow">
      <template #header><span /></template>
    </PageMain>

    <ContainerSelector
      :visible.sync="selectorVisible"
      :shipmentCode="shipmentCode"
      :shipmentBookingCode="shipmentBookingCode"
      :containers="selectedList"
      @confirm="onSelectorConfirm"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import ContainerSelector from '../container-selector/index'

export default {
  components: { PageMain, ContainerSelector },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    listContainer: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectorVisible: false,
      selectedList: [],
    }
  },
  watch: {
    listContainer: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.selectedList = val.map((item) => ({ ...item }))
        } else {
          this.selectedList = []
        }
      },
    },
  },
  methods: {
    onSelectorConfirm(rows) {
      const selectedCodes = new Set(rows.map((r) => r.shipmentContainerCode))
      const kept = this.selectedList.filter((item) =>
        selectedCodes.has(item.shipmentContainerCode)
      )
      const keptCodes = new Set(kept.map((item) => item.shipmentContainerCode))
      const added = rows
        .filter((r) => !keptCodes.has(r.shipmentContainerCode))
        .map((r) => ({
          ...r,
          shipmentBookingContainerCode: '',
          bookingNo: '',
          customsNo: '',
        }))
      this.selectedList = [...kept, ...added]
      this.selectorVisible = false
    },
    updateRow(row, field, value) {
      const item = this.selectedList.find(
        (s) => s.shipmentContainerCode === row.shipmentContainerCode
      )
      if (item) this.$set(item, field, value)
    },
    removeItem(row) {
      this.selectedList = this.selectedList.filter(
        (item) => item.shipmentContainerCode !== row.shipmentContainerCode
      )
    },
    getListContainers() {
      return this.selectedList.map((item) => ({
        shipmentBookingContainerCode: item.shipmentBookingContainerCode || '',
        shipmentContainerCode: item.shipmentContainerCode,
        bookingNo: item.bookingNo || '',
        customsNo: item.customsNo || '',
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.ebc-root {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.ebc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px 4px;
  flex-shrink: 0;
}

.ebc-header__title {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  svg { color: #409eff; }
}
</style>
